
import React from "react";
import MagicFlow from "@/components/magic-flow/MagicFlow";

export default function MagicFlowPage() {
  return <MagicFlow />;
}
